import moment from 'moment'
/**
 * Utilitários para manipulação de datas com base no fuso do navegador.
 */

/**
 * Retorna a data atual no formato YYYY-MM-DD com hora zerada no fuso local.
 */
export function getDataAtual() {
  const hoje = new Date()
  const ano = hoje.getFullYear()
  const mes = String(hoje.getMonth() + 1).padStart(2, '0')
  const dia = String(hoje.getDate()).padStart(2, '0')
  return `${ano}-${mes}-${dia}` // formato local 'YYYY-MM-DD'
}
/**
 * Retorna a hora atual no formato HH:mm:ss no fuso local.
 */
export function getHoraAtual() {
  const agora = new Date()
  return agora.toTimeString().split(' ')[0] // HH:mm:ss
}

/**
 * Retorna o primeiro dia do mês atual no formato YYYY-MM-DD.
 */
export function getFirstDayOfMonth() {
  const hoje = new Date()
  const ano = hoje.getFullYear()
  const mes = String(hoje.getMonth() + 1).padStart(2, '0')
  return `${ano}-${mes}-01`
}

/**
 * Retorna a data atual no formato YYYY-MM-DD (alias para getDataAtual).
 */
export function getCurrentDate() {
  return getDataAtual()
}

/**
 * Retorna a data e hora atual no formato YYYY-MM-DDTHH:mm:ss no fuso local.
 */
export function getDataHoraAtual() {
  const agora = new Date()
  const localISO = new Date(agora.getTime() - agora.getTimezoneOffset() * 60000)
  return localISO.toISOString().slice(0, 19) // YYYY-MM-DDTHH:mm:ss
}

function formatarPartesData(ano, mes, dia) {
  return `${ano}-${String(mes).padStart(2, '0')}-${String(dia).padStart(2, '0')}`
}

function extrairDataPura(data) {
  if (!data) return ''

  if (typeof data === 'string') {
    const texto = data.trim()
    const iso = texto.match(/^(\d{4})-(\d{2})-(\d{2})/)
    if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}`

    const br = texto.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
    if (br) return `${br[3]}-${br[2]}-${br[1]}`
  }

  const m = moment(data)
  if (!m.isValid()) return ''

  return m.format('YYYY-MM-DD')
}

/**
 * Soma dias ou meses a uma data e retorna no formato YYYY-MM-DD.
 * @param {string|Date} dataBase - Data inicial.
 * @param {number} quantidade - Quantidade de dias ou meses a adicionar.
 * @param {'dias'|'meses'} tipo - Tipo de incremento.
 */
export function getAcrescentarData(dataBase, quantidade, tipo = 'dias') {
  const data = new Date(dataBase + 'T00:00:00') // garante local
  quantidade = parseInt(quantidade, 10) // garante número inteiro (evita concatenação de string)

  // Converte múltiplos exatos de 30 para meses, se o tipo for 'dias'
  if (tipo === 'dias' && quantidade % 30 === 0) {
    tipo = 'meses'
    quantidade = quantidade / 30
  }

  if (tipo === 'dias') {
    data.setDate(data.getDate() + quantidade)
  } else if (tipo === 'meses') {
    data.setMonth(data.getMonth() + quantidade)
  }

  return formatarPartesData(data.getFullYear(), data.getMonth() + 1, data.getDate())
}


/**
 * Calcula a diferença de dias entre duas datas.
 * @param {string|Date} dataInicial - Data inicial.
 * @param {string|Date} dataFinal - Data final.
 * @returns {number} Quantidade de dias entre as datas.
 */
export function getDiasEntreDatas(dataInicial, dataFinal) {
  const dt1 = new Date(dataInicial + 'T00:00:00')
  const dt2 = new Date(dataFinal + 'T00:00:00')
  const diff = dt2 - dt1
  return Math.floor(diff / (1000 * 60 * 60 * 24))
}

/**
 * Verifica se uma data é válida.
 * @param {string|Date} data
 * @returns {boolean}
 */
export function isDataValida(data) {
  const d = new Date(data)
  return d instanceof Date && !isNaN(d)
}

/**
 * Formata uma data para o formato brasileiro DD/MM/YYYY.
 */
export function formatarDataBR(data) {
  if (!data) return ''

  const dataPura = extrairDataPura(data)
  if (!dataPura) return ''

  const [ano, mes, dia] = dataPura.split('-')
  return `${dia}/${mes}/${ano}`
}
/*
export function formatarDataBR(data) {
  if (!data) return ''

  const d = new Date(data)
  if (isNaN(d)) return ''

  const dia = String(d.getDate()).padStart(2, '0')
  const mes = String(d.getMonth() + 1).padStart(2, '0')
  const ano = d.getFullYear()
  return `${dia}/${mes}/${ano}`
}
*/
/**
 * Converte qualquer data (string ou Date) para 'YYYY-MM-DD' sem afetar o fuso horário.
 * Ideal para preencher <b-form-input type="date">
 */
export function formatarDataParaInput(data) {
  if (!data) return ''

  if (typeof data === 'string') {
    const texto = data.trim()
    const matchIso = texto.match(/^(\d{4})-(\d{2})-(\d{2})/)

    if (matchIso) {
      const [, ano, mes, dia] = matchIso
      return `${ano}-${mes}-${dia}`
    }

    const dataBr = moment(texto, 'DD/MM/YYYY', true)
    if (dataBr.isValid()) return dataBr.format('YYYY-MM-DD')
  }

  const m = moment(data)
  if (!m.isValid()) return ''

  return m.format('YYYY-MM-DD')
}

export function exibirMensagem(store, titulo, variant, err) {
  let mensagem = ''

  try {
    if (err && err.response && err.response.data != null) {
      if (typeof err.response.data === 'string') {
        mensagem = err.response.data
      } else if (err.response.data.message) {
        mensagem = err.response.data.message
      } else {
        mensagem = JSON.stringify(err.response.data)
      }
    } else if (typeof err === 'string') {
      mensagem = err
    } else if (err && err.message) {
      mensagem = err.message
    } else {
      mensagem = 'Erro desconhecido'
    }
  } catch (e) {
    mensagem = 'Erro inesperado: ' + (e.message || e)
  }

  store.dispatch('mensagem/exibirToast', {
    titulo,
    mensagem,
    variant
  })
}

export function formatarDataHoraBR(data) {
  const d = new Date(data)
  if (isNaN(d)) return ''

  const dia = String(d.getDate()).padStart(2, '0')
  const mes = String(d.getMonth() + 1).padStart(2, '0')
  const ano = d.getFullYear()

  const hora = String(d.getHours()).padStart(2, '0')
  const min = String(d.getMinutes()).padStart(2, '0')
  const seg = String(d.getSeconds()).padStart(2, '0')

  return `${dia}/${mes}/${ano} ${hora}:${min}:${seg}`
}


export function voltar(contextoVue) {
  const ultima = localStorage.getItem('ultimaRota')
  const rotaAtual = contextoVue.$route.fullPath

  if (ultima && ultima !== rotaAtual) {
    contextoVue.$router.push(ultima)
  } else {
    contextoVue.$router.push('/dashboard/painelgerencial')
  }
}

export function removerMascaraCNPJ(cnpj) {
    if (!cnpj) return ''
    return cnpj.replace(/[^\d]+/g, '')
  }

  /**
   * Arredonda um valor numérico para o número de casas decimais especificado.
   * @param {number} valor - Valor a ser arredondado.
   * @param {number} casasDecimais - Número de casas decimais (padrão: 2).
   * @returns {number}
   */
  export function arredondarValor(valor, casasDecimais = 2) {
    if (typeof valor !== 'number' || isNaN(valor)) return 0
    const fator = Math.pow(10, casasDecimais)
    return Math.round(valor * fator) / fator
  }

  /**
 * Reseta todos os atributos de um objeto simples (1 nível) para null
 * 
 * @param {Object} obj - O objeto original
 * @param {boolean} [mutate=false] - Se true, altera o objeto original. 
 *                                   Se false, retorna um novo objeto.
 * @returns {Object} Objeto com todos os atributos null
 */
export function resetToNull(obj, mutate = false) {
  if (mutate) {
    Object.keys(obj).forEach(key => {
      obj[key] = null;
    });
    return obj; // retorna o mesmo objeto alterado
  } else {
    return Object.keys(obj).reduce((acc, key) => {
      acc[key] = null;
      return acc;
    }, {});
  }
}

/**
 * Formata um número de telefone para o padrão (99)99999-9999.
 * Aceita apenas dígitos e ignora outros caracteres.
 * @param {string} telefone
 * @returns {string}
 */
export function formatarTelefone(telefone) {
  if (!telefone) return ''
  const digits = telefone.replace(/\D/g, '')
  if (digits.length < 10) return telefone // não tenta formatar se não tem dígitos suficientes

  const ddd = digits.slice(0, 2)
  const parte1 = digits.slice(2, 7)
  const parte2 = digits.slice(7, 11)
  return `(${ddd})${parte1}-${parte2}`
}

/**
 * Formata um valor numérico para o padrão de moeda brasileiro (R$).
 * @param {number} valor - Valor a ser formatado.
 * @returns {string}
 */
export function formatCurrency(valor) {
  return valor != null ? valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00'
}

/**
 * Formata uma quantidade com o número de casas decimais especificado.
 * @param {number} valor 
 * @param {number} casas 
 */
export function formatarQuantidade(valor, casas = 3) {
  if (valor == null) return '0'
  return Number(valor).toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas })
}

const Tools = {
  getDataAtual,
  getHoraAtual,
  getDataHoraAtual,
  getAcrescentarData,
  getDiasEntreDatas,
  isDataValida,
  formatarDataBR,
  formatarDataParaInput,
  exibirMensagem,
  formatarDataHoraBR,
  voltar,
  removerMascaraCNPJ,
  arredondarValor,
  resetToNull,
  formatarTelefone,
  formatCurrency,
  formatarQuantidade,
  getFirstDayOfMonth,
  getCurrentDate
}

export default Tools



// WEBPACK FOOTER //
// ./src/tools/tools.js